import { render, staticRenderFns } from "./PropertyPriceSettings.vue?vue&type=template&id=f2d2883c&scoped=true&"
import script from "./PropertyPriceSettings.vue?vue&type=script&lang=js&"
export * from "./PropertyPriceSettings.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPriceSettings.vue?vue&type=style&index=0&id=f2d2883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d2883c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VDataTable,VDialog,VIcon,VSelect,VSkeletonLoader})
